// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import './assets/reset.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import axios from 'axios'

Vue.use(Vant)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
import AMap from 'vue-amap';
Vue.use(AMap);

// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: '9b4aa07fbe96e58629fffd1ec80b2c2d',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Geolocation']
});

// const baseApi = 'https://sanrenxingteam.com/index.php/executor/';
Vue.filter('dateFormat', function (originVal) {
  const dt = new Date(originVal * 1000)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  //时间格式年月日、时分秒
  return `${y}-${m}-${d}`
})

Vue.prototype.$api = 'https://sanrenxingteam.com/index.php/executor/'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  store,
  axios,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js